// extracted by mini-css-extract-plugin
export default {"container":"new_container__aQBwj","buttons":"new_buttons__JA8pY","title":"new_title__rYtlQ"};